'use strict';
import React, { PureComponent } from 'react';


class ImportarModelosBuscador extends PureComponent {
    constructor(props) {
        super(props);

        this.buscarModelos = this.buscarModelos.bind(this);
    }

    buscarModelos(valorInput, descripcionModelo, esModeloSeleccionado, codigoSeleccionado) {
        this.props.buscarModelosImportar(valorInput, descripcionModelo, esModeloSeleccionado, codigoSeleccionado);
    }

    render() {
        const { modelo } = this.props;

        let descripcionModelo = modelo.Codigo + " - " + modelo.Descripcion

        return (
            <div className="ABMModelos__opcionBuscadorCuentasContables ABMModelos__opcionBuscadorImportarModelos" onClick={() => this.buscarModelos("", descripcionModelo, true, modelo.Codigo)}>
                {descripcionModelo}
            </div>
        );
    }
}

export default ImportarModelosBuscador;